import { createConfig, http } from 'wagmi';
import { base } from 'wagmi/chains';
import { injected } from 'wagmi/connectors';

const rpcUrl = import.meta.env.VITE_BASE_RPC_URL?.trim() || 'https://mainnet.base.org';
const chains = [base] as const;
const transports = { [base.id]: http(rpcUrl) };

// Kyndo intentionally supports installed EIP-1193 browser wallets only.
// No Reown/WalletConnect cloud project is required for public launches.
export const wagmiConfig = createConfig({
  chains,
  connectors: [injected({ shimDisconnect: true })],
  multiInjectedProviderDiscovery: true,
  transports,
});
